import * as React from "react";
import './FormWWD.css'
import {formStores} from "../../state/mobx";
import FormStepper from "../../components/FormStepper/FormStepper";
import {InputTypes} from "../../components/FormStepper/InputTypes";
import {RouteComponentProps} from "react-router";
import FormButton from "../../../../components/FormButton/FormButton";
import {observer} from "mobx-react";
import {observe} from "mobx";
import LottieAnimation from "../../../../components/LottieAnimation/LottieAnimation";
import FormFinish from "../SignUpForm/FormFinish/FormFinish";

interface IProps  extends RouteComponentProps<any> {
    closeWindowNavigationPath : string;
    closeModal: ()=> void;
}

interface ILocalState {
    currentStep: number;
    isFirstWWOffice: number;
    plaidCompleted: boolean;
    showFinishAnimation: boolean
}

const STORE = formStores.formStore;
const storePropertyName = 'weWorkDemo';

@observer
export default class FormWWD  extends React.Component<
    IProps,
    ILocalState
    > {

    public state: ILocalState = {
        currentStep: 1,
        isFirstWWOffice: 0,
        plaidCompleted: false,
        showFinishAnimation: true
    };

    public disposer = observe(STORE, (change) => {
        if (change.name === "WWModalPlaidFlag") {
            const newState = this.state;
            newState.plaidCompleted = true;
            this.setState(newState);
        }
    });

    constructor (props: IProps) {
        super(props);
        STORE.formInput[storePropertyName] = {};
    }

    public getSteps = () => {
        if(this.state.currentStep === 1) {
            return [
                {
                    isHeader: true,
                    title: "Business",
                    inputType: InputTypes.none
                },
                {
                    title: "Your full name",
                    inputPlaceHolder: "Write here...",
                    inputType: InputTypes.text,
                    propName: "WWfullName"
                },
                {
                    title: "Work email address",
                    inputPlaceHolder: "Write here...",
                    inputType: InputTypes.email,
                    propName: "WWuserEmail",
                },
                {
                    title: "Full business name",
                    inputPlaceHolder: "Write here...",
                    inputType: InputTypes.text,
                    propName: "WWuserCompanyName"
                },
                {
                    title: "Your phone number",
                    inputPlaceHolder: "(123) 456-7890",
                    inputType: InputTypes.text,
                    propName: "WWuserPhone"
                },
                {
                    title: "Your SSN",
                    inputPlaceHolder: "123-45-6789",
                    inputType: InputTypes.text,
                    propName: "WWuserSSN"
                }
            ] as any;
        } else if (this.state.currentStep === 2) {
            return [
                {
                    isHeader: true,
                    title: "Finances",
                    inputType: InputTypes.none
                },
                {
                    title: "Is this your first WeWork office",
                    inputPlaceHolder: "Write here...",
                    inputType: InputTypes.boolean,
                    options: [
                        {
                            text: "Yes",
                            cta: this.cta
                        } ,
                        {
                            text: "Not yet",
                            cta: this.cta
                        }
                    ],
                    selectedOption: this.state.isFirstWWOffice,
                    propName: "WWfirstOffice"
                },
                {
                    title: "verify security deposit amount",
                    inputType: InputTypes.amount,
                    propName: "WWdeposit",
                },
                {
                    title: "Connect your bank account",
                    subTitle: "Private and secured",
                    inputType: InputTypes.button,
                    propName: "WWplaidConnection"
                }
            ] as any;
        }
        return [
            {
                isHeader: true,
                title: "Business",
                inputType: InputTypes.none
            },
            {
                title: "Your full name",
                inputPlaceHolder: "Write here...",
                inputType: InputTypes.text,
                propName: "WWfullName"
            },
            {
                title: "Work email address",
                inputPlaceHolder: "Write here...",
                inputType: InputTypes.email,
                propName: "WWuserEmail",
            },
            {
                title: "Full business name",
                inputPlaceHolder: "Write here...",
                inputType: InputTypes.text,
                propName: "WWuserCompanyName"
            },
            {
                title: "Your phone number",
                inputPlaceHolder: "(123) 456-7890",
                inputType: InputTypes.text,
                propName: "WWuserPhone"
            },
            {
                title: "Your SSN",
                inputPlaceHolder: "123-45-6789",
                inputType: InputTypes.text,
                propName: "WWuserSSN"
            }
        ] as any;

    };

    public renderSteps = () => {
        return <><FormStepper steps={this.getSteps()} store={STORE} navigationProperty={storePropertyName}/></>
    };

    public cta = (e: React.MouseEvent) => {
        const newState = this.state;
        newState.isFirstWWOffice = e.currentTarget.textContent!.trim() === "Yes"? 1 : 2;
        this.setState(newState);
    }

    public navigateForward = () => {
        const newState = this.state;
        newState.currentStep ++;
        this.setState(newState);
    };

    public renderButton = () => {
        return this.state.currentStep === 1? <FormButton click={this.navigateForward} btnText={'Next'} classes={"blue"}/> : null;
    };

    public renderCompleted = () => {
        setTimeout(() => {
            const newState = this.state;
            newState.showFinishAnimation = false;
            this.setState(newState);
        }, 1500);
        return this.state.showFinishAnimation?
            <> <LottieAnimation animationName={'LOADING_COLORS'} /> </> :
            <>
                <FormFinish store={STORE} isWWDemo={true} {...this.props}/>
                <div className="ww-close-modal" onClick={this.props.closeModal}>Close</div>
            </>
    };

    public render = () => {
        {return this.state.plaidCompleted?
            (<>{this.renderCompleted()}</>):
            (<>
                {STORE.WWModalPlaidFlag? <div>DONE</div>: this.renderSteps()}
                {this.renderButton()}
            </>)}
    }
}


// WEBPACK FOOTER //
// ./src/scenes/Forms/screens/FormWWD/FormWWD.tsx